import { Box, Flex } from "@chakra-ui/react";
import Markdown from "markdown-to-jsx";

interface Props {
  children: string;
  p?: number;
  mb?: number;
  "data-tid"?: string;
}

export default function MarkdownContent({ children, p, mb, "data-tid": dataTid }: Props) {
  const marginBottom = typeof mb !== undefined ? mb : 10;

  return (
    <Flex mb={marginBottom} alignItems={"center"} flexDirection={"column"}>
      <Box
        w="full"
        maxWidth={"800px"}
        className="markdown"
        backgroundColor="#fff"
        p={p ?? 5}
        data-tid={dataTid}
      >
        <Markdown>{children}</Markdown>
      </Box>
    </Flex>
  );
}
